import { Color, CylinderBufferGeometryProps, MeshProps } from "@react-three/fiber";

type CenteredCylinderProps = CylinderBufferGeometryProps & MeshProps & {
    color: Color,
    radius: number,
    height: number
}


export const CenteredCylinder = (props: CenteredCylinderProps) => {
    return (
        <>
            <mesh position={props.position} rotation={props.rotation}>
                <cylinderBufferGeometry args={[props.radius, props.radius, props.height * 2, 64]} {...props} />
                <meshStandardMaterial color={props.color} />
            </mesh>
        </>
    );
};

